import { formatText } from 'helpers/formatters';
const endpoints = {
    profile: {
        getUserProfile: { url: '/user-profile/UserProfile', version: '1.0' },
        updateUserProfile: { url: '/user-profile/UserProfile', version: '1.0' },
        getAvailableLanguages: { url: '/user-profile/Languages', version: '1.0' }
    },
    log: {
        getIssueTypes: { url: '/user-profile/IssueTypes', version: '1.0' },
        reportIssue: { url: '/user-profile/IssueReport/Create', version: '1.0' },
    },
    subscription: {
        getSubscriptionList: { url: 'subscription/Subscriptions/Search', version: '1.0' },
        getSubscriptionTypes: { url: 'subscription/SubscriptionTypes?organizationId={organizationId}', version: '1.0' }
    },
    system: {
        getAssetList: { url: '/organization/Assets/Search', version: '1.0' },
        ciamSearchOrganization: { url: '/organization/Organizations/Ciam/Search', version: '1.0' }
    },
    powertrain: {
        getPowertrains: { url: '/organization/Powertrains/Search', version: '1.0' },
        getPowertrain: { url: '/organization/Powertrains/{id}', version: '1.0' },
        deletePowertrain: { url: '/organization/Powertrains/{id}', version: '1.0' },
        addPowertrain: { url: '/organization/Powertrains', version: '1.0' },
        updatePowertrain: { url: '/organization/Powertrains', version: '1.0' },
        addPowertrainAssets: { url: '/organization/Powertrains/{id}/Assets', version: '1.0' }
    },
    powertrainV2: {
        getPowertrains: { url: '/organization/Powertrains/SearchPowertrains', version: '1.0' },
        deletePowertrain: { url: '/organization/Powertrains/{id}', version: '1.0' },
        addPowertrain: { url: '/organization/Powertrains/CreatePowertrain', version: '1.0' },
        updatePowertrain: { url: '/organization/Powertrains/EditPowertrain', version: '1.0' },
        getAvailableAssets: { url: '/organization/Powertrains/GetAvailableAssets', version: '1.0' },
        getAssetDetails: { url: '/organization/Powertrains/GetAssetsDetails', version: '1.0' },
        getAssetSubTypes: { url: '/organization/Assets/SubTypes?typeConfigId={typeConfigId}', version: '1.0' },
        getHierarchyData: { url: '/organization/Organizations/{organizationId}/FullHierarchy', version: '1.0' },
        updateHierarchyData: { url: '/organization/Sites/{siteId}/FullHierarchy/Batch', version: '1.0' },
        convertToLocation: { url: '/organization/Powertrains/{id}/ConvertToLocation', version: '1.0' }
    },
    site: {
        getSites: { url: '/organization/Sites/Search', version: '1.0' },
    },
    environmentProperties: { url: '/user-profile/EnvironmentVariables', version: '1.0' },
    analytics: {
        HistogramV2Config: { url: '/analytics/analytics/histogram/config/{assetId}', version: '1.0' },
        HistogramV2Data: { url: '/analytics/analytics/histogram/data?from={from}&to={to}', version: '1.0' },
        ScatterV2Config: { url: '/analytics/analytics/scatter/config?assetId={assetId}', version: '1.0' },
        ScatterV2Data: { url: '/analytics/analytics/scatter/data?from={from}&to={to}', version: '1.0' },
    },
    copilotKit: {
        aguiEvents: { url: '/chat/ag-ui/events', version: '1.0' }
    },
    timeSeries: {
        MeasurementType: { url: '/timeseries/timeseries/trend/config?assetId={assetId}', version: '1.0' },
        Trend: { url: '/timeseries/timeseries/trend/data?from={from}&to={to}', version: '1.0', featureCode: 'WEB_AssetTrendData' },
        getCommentsList: { url: '/timeseries/Timeseries/Comments?from={from}&to={to}', version: '1.0' },
        createandEditComment: { url: '/timeseries/Timeseries/Comments', version: '1.0' },
        deleteComment: { url: '/timeseries/Timeseries/Comments/{commentId}', version: '1.0' },
    },
    organizationManagement: {
        getUserOrganizations: { url: '/organization/Organizations/Search', version: '1.0' },
        getOrganizationByAsset: { url: '/organization/Organizations/SearchByAsset/{filter}', version: '1.0' },
        getMaintenanceScheduleMicroService: { url: '/sensor/Organization/{organizationId}/Maintenance', version: '1.0' },
        addMaintenanceScheduleMicroService: { url: '/sensor/Organization/{organizationId}/Maintenance?scheduleId={scheduleId}', version: '1.0' },
        getLastSelectedOrganization: { url: '/organization/Organizations/LastSelected', version: '1.0' },
        updateLastSelectedOrganization: { url: '/organization/Organizations/LastSelected', version: '1.0' },
    },
    eventLogs: {
        eventSearch: { url: '/eventservice/Events/Search', version: '1.0' },
        eventComment: { url: '/eventservice/EventComments', version: '1.0' },
        deleteComment: { url: '/eventservice/EventComments/{id}', version: '1.0' },
        eventComments: { url: '/eventservice/Events/{id}/Comments', version: '1.0' },
        loggerId: { url: '/eventservice/Events/{id}/Attachments', version: '1.0' },
        logger: {
            loggers: { url: '/datalogger/DataLogger/Logger/{loggerId}', version: '1.0' },
            downloadLogger: { url: '/datalogger/DataLogger/Download/{loggerId}', version: '1.0' },
            signal: { url: '/datalogger/DataLogger/Signals/{loggerId}', version: '1.0' },
        },
        fileservice: {
            downloadFile: { url: '/fileservice/Files/{fileId}/Download', version: '1.0' },
        }
    },
    limitConfiguration: {
        getLimitConfigurations: { url: '/asset/timeseries/limits', version: '1.0' },
        getTimeseriesLimits: { url: '/timeseries/timeseries/limits?assetId={assetId}', version: '1.0' },
        postTimeseriesLimits: { url: '/timeseries/timeseries/limits', version: '1.0' },
        getLimitKpi: { url: '/timeseries/timeseries/trend/config?assetId={assetId}', version: '1.0' },
        getSuggestedLimits: { url: '/analytics/limits/suggested?assetId={assetId}&timeseriesKey={timeseriesKey}', version: '1.0' },
        getDefaultLimits: { url: '/timeseries/timeseries/limits/default', version: '1.0' }
    },
    parameterFile: {
        getListV2: { url: '/driveparameters/DriveParameters/{assetId}/List', version: '1.0' },
        downloadV2: { url: '/driveparameters/DriveParameters/{fileId}/Download', version: '1.0' },
        changedParametersV2: { url: 'driveparameters/DriveParameters/{assetId}/ParameterChanges?startTime={from}&endTime={to}', version: '1.0' },
        getTypesV2: { url: '/datacollectionunit/DataCollectionUnit/Drive/{assetId}/ParameterBackup/Types', version: '1.0' },
    },
    BulkUpload: {
        getStatus: { url: 'datacollectionunit/DataCollectionUnit/BulkUpload/Status/{assetId}?startDate={startDate}&endDate={endDate}', version: '1.0' },
        getSasUrl: { url: 'datacollectionunit/DataCollectionUnit/BulkUpload/sasUrl', version: '1.0' },
        startBulkUpload: { url: 'datacollectionunit/DataCollectionUnit/BulkUpload/start/{assetId}', version: '1.0' },
    },
    assetDetails: {
        getAssetGroups: { url: '/organization/AssetGroups/Search', version: '1.0' },
        getAssetDetails: { url: '/asset/assets/{assetID}/detail', version: '1.0' },
        getAssetOverview: { url: '/asset/Assets/{assetID}/Overview', version: '1.0' },
        getSensorOfAssets: { url: '/asset/assets/GetSensorOfAsset', version: '1.0' },
        getSmartConditionSummary: { url: '/analytics/analytics/condition/asset/smartsummary/{assetId}', version: '1.0' },
        getPhysicalConnectionsByAsset: { url: '/organization/Powertrains/GetPhysicalConnectionsByAsset', version: '1.0' },
        fftV2Data: {
            getFFTV2Data: { url: '/fftservice/FFT/Portal/{assetID}/LastFFTFile', version: '1.0' },
            downloadRawDataV2: { url: '/fftservice/FFT/Portal/DownloadRawDataFiles', version: '1.0' },
            getFFTTimestampList: { url: '/fftservice/FFT/Portal/{assetID}/FFTFiles?startTime={startTime}&endTime={endTime}', version: '1.0' },
            getFFTDataByTimestamp: { url: '/fftservice/FFT/Portal/FFTByTimestamps', version: '1.0' },
        },
        pictures: {
            getAssetNameplatePicturesV2: { url: '/asset/assets/{assetID}/pictures', version: '1.0' },
            generateUploadURL: { url: '/asset/assets/{assetID}/picture/uploadUrl', version: '1.0' },
            uploadAssetPicture: { url: '/asset/assets/{assetID}/pictures', version: '1.0' },
            deleteAssetPicture: { url: '/asset/Assets/{assetID}/Pictures/{pictureId}', version: '1.0' }
        },
        tags: {
            getTags: { url: '/organization/Assets/{assetID}/Tags', version: '1.0' },
            addTags: { url: '/organization/Assets/{assetID}/Tags', version: '1.0' },
            deleteTags: { url: '/organization/AssetTag/{tagID}', version: '1.0' },
            getSuggestedTags: { url: '/organization/Organizations/{organizationID}/Tags', version: '1.0' }
        }

    },
    assetAdmin: {
        assignSerialNumber: { url: '/asset/Assets/{assetId}/AssignSerialNumber', version: '1.0' },
        validateSerialNumber: { url: '/asset/Assets/ValidateSerialNumber/{oldSerialNumber}', version: '1.0' },
        enableDisableDrive: { url: '/asset/Assets/Drive/{assetId}/EnableDisable', version: '1.0' }
    },
    assetGroup: {
        importToLocation: { url: '/organization/Organizations/AssetGroup/ImportToLocation', version: '1.0' }
    },
    component: {
        exportExcelForMeasurementTypeGroup: {
            url: '/timeseries/timeseries/export?assetId={assetId}&from={from}&to={to}&locale=en-us',
            version: '1.0',
        },
        loadMeasurement: {
            url: '/datacollectionunit/DataCollectionUnit/SmartSensorAsset/{assetId}/LoadMeasurement',
            version: '1.0',
        },
        collectRawData: {
            url: '/datacollectionunit/DataCollectionUnit/SmartSensorAsset/{assetId}/CollectRawData',
            version: '1.0',
            featureCode: 'WEB_LoadRawData'
        },
        getSensorLastCommand: {
            url: '/datacollectionunit/DataCollectionUnit/SmartSensorAsset/{assetId}/{requestType}/Last',
            version: '1.0',
        },
        getDriveEventsSummary: {
            url: '/analytics/Analytics/ConditionDetails/DriveEventsSummary/{assetId}',
            version: '1.0',
        },
        getDriveEventsCurrentDay: {
            url: '/analytics/Analytics/ConditionDetails/DriveEventsCurrentDay/{assetId}',
            version: '1.0',
        }
    },
    userProfile: {
        acceptEULA: { url: '/user-profile/UserProfile/AcceptEULA', version: '1.0' }
    },
    maintenance: {
        getAssetsV2: { url: '/analytics/analytics/maintenance/overview?organizationId={organizationId}', version: '1.0' },
        getDetailsV2: { url: '/analytics/analytics/maintenance/detail?assetId={assetId}', version: '1.0' },
        getLubricationDetails: { url: '/analytics/Analytics/Maintenance/Lubrication?assetId={assetId}', version: '1.0' },
        getLubricationMaintenanceInfo: { url: '/analytics/analytics/maintenance/info/{assetId}', version: '1.0' },
        updateLubricationMaintenanceInfo: { url: '/analytics/Analytics/Maintenance/LubricationDates', version: '1.0' },
    },
    report: {
        getReports: { url: '/reporting/Report/List', version: '2.0' },
        downloadReport: { url: '/reporting/Report/Download?reportId={reportId}', version: '2.0' },
        generateReport: { url: '/reporting/Report/RequestReport', version: '2.0' },
        uploadReport: { url: '/reporting/Report/Upload/StatusUpdate', version: '2.0' },
        uploadReportInit: { url: '/reporting/Report/Upload/Init', version: '2.0' },
        publishReport: { url: '/reporting/Report/Publish/{reportId}', version: '2.0' },
        rejectReport: { url: '/reporting/Report/Reject/{reportId}', version: '2.0' },
        generateFleetReport: { url: '/reporting/Report/RequestReport', version: '2.0' },
        deleteReport: { url: '/reporting/Report/Delete/{reportId}/Organization/{organizationId}', version: '2.0' },
        rawDataCollections: { url: '/fftservice/FFT/Portal/{assetId}/RawDataFileByTimeRange?startTime={startTime}&endTime={endTime}', version: '1.0' },
    },
    capability: {
        getCapabilities: { url: '/subscription/Capabilities/Search', version: '1.0' },
        checkCapabilities: { url: '/subscription/Capabilities/Check', version: '1.0' },
    },
    notification: {
        deleteUserBroadcastMessage: { url: '/user-profile/UserProfile/Broadcast/DeleteMessage?broadcastMessageId={broadcastMessageId}&userId={userId}', version: '1.0' },
        getBroadcastedMessages: { url: '/user-profile/UserProfile/Broadcast/GetMessages', version: '1.0' },
    },
    dailyAgingStress: {
        getDailyAgingStressV2: { url: '/analytics/analytics/maintenance/lifetimeimpact?assetId={assetId}&startDate={startDate}&endDate={endDate}', version: '1.0' },
    },
    conditionIndices: {
        getAssetOverview: { url: '/analytics/analytics/condition/asset', version: '1.0' },
        getAssetConditionInsights: { url: '/analytics/analytics/condition/asset/{assetID}?startTime={startTime}&endTime={endTime}', version: '1.0' },
        getRetrainingProgress: { url: '/analytics/analytics/anomaly/retraining/trigger', version: '1.0' },
        getAssetGroupOverview: { url: '/analytics/analytics/condition/assetgroup', version: '1.0' },
        getPowertrainOverview: { url: '/analytics/analytics/condition/powertrain', version: '1.0' },
        getHierarchyConditionIndices: { url: '/analytics/analytics/condition/hierarchy?organizationId={organizationId}', version: '1.0' }
    },
    assetRename: {
        updateAssetList: { url: '/asset/assets/{assetId}/name', version: '1.0' }
    },
    notifications: {
        getNotificationSettings: { url: '/notification/Notification/Settings?organizationId={organizationId}', version: '1.0' },
        saveNotificationSettings: { url: '/notification/Notification/Settings?organizationId={organizationId}', version: '1.0' },
        getMutedAssetList: { url: '/notification/MutedAssets/Search', version: '1.0' },
        deleteMutedAssets: { url: '/notification/MutedAssets', version: '1.0' },
        getAssetMuteSettings: { url: '/notification/MutedAssets/{assetID}', version: '1.0' },
        updateAssetMuteSettings: { url: '/notification/MutedAssets', version: '1.0' },
        getMuteBulkAssets: { url: '/notification/MutedAssets/Bulk', version: '1.0' },
        getNofiticationList: { url: '/notification/notificationCenter/messages', version: '1.0' },
        getMutedNofiticationList: { url: '/notification/MutedAssets/NotificationGroups', version: '1.0' },
        readNofitication: { url: '/notification/notificationcenter/messages/{groupId}', version: '1.0' },
        copyNotificationSettings: { url: '/notification/Notification/Settings/Copy', version: '1.0' }
    },
    sensor: {
        getSensorProperties: { url: '/sensor/Sensor/{id}', version: '1.0' },
        getSensorGatewayInfo: { url: '/asset/Assets/Sensor/{sensorId}', version: '1.0' },
        getSensorTimeseriesConfig: { url: '/timeseries/timeseries/trend/sensor/config?sensorId={sensorId}', version: '1.0' },
        getSensorTimeSeries: { url: '/timeseries/timeseries/lastvaluebysensor', version: '1.0' },
        getRssiValue: { url: '/timeseries/timeseries/sensor/rssiaverage?sensorId={sensorId}', version: '1.0' },
        getSensorBatteryLevel: { url: '/timeseries/timeseries/sensor/batterylevel', version: '1.0' },
    },
    gatewayManagement: {
        getGatewayList: { url: '/datacollectionunit/DataCollectionUnit/GatewayManagement/Search', version: '1.0' },
        getGatewayType: { url: '/datacollectionunit/DataCollectionUnit/GatewayTypeNames', version: '1.0' },
        getGatewayDetails: { url: '/datacollectionunit/DataCollectionUnit/Gateways/getDetail', version: '1.0' },
        getGatewayConnectedAssets: { url: '/datacollectionunit/DataCollectionUnit/Gateways/getAssets', version: '1.0' },
        parameterBackup: { url: '/datacollectionunit/DataCollectionUnit/Drives/{assetId}/Parameter/Upload?formatType={formatType}', version: '1.0' },
        gatewayRename: { url: '/datacollectionunit/DataCollectionUnit/Gateways/{gatewayId}/Name', version: '1.0' },
        refreshGateway: { url: '/datacollectionunit/DataCollectionUnit/Gateways/{gatewayID}/Refresh', version: '1.0' },
        rebootGateway: { url: '/datacollectionunit/DataCollectionUnit/Gateways/{gatewayId}/Reboot', version: '1.0' },
        activateDeactivateGateway: { url: '/datacollectionunit/DataCollectionUnit/Gateways/{gatewayID}/ActivateDeactivate', version: '1.0' },
        updateFirmware: { url: '/datacollectionunit/DataCollectionUnit/Gateways/{gatewayID}/TriggerFirmwareUpdate', version: '1.0' },
        deleteGateway: { url: '/datacollectionunit/DataCollectionUnit/GatewayManagement/{gatewayId}', version: '1.0' },
        disconnectGatewayAsset: { url: '/asset/Assets/Drive/{assetId}/DisconnectDriveFromGateway', version: '1.0' },
        deleteGatewayAsset: { url: '/asset/Assets/{assetId}', version: '1.0' },
        moveGatewayAsset: { url: '/asset/Assets/Drive/NetaGateway/Move', version: '1.0' },
        validateGatewayAsset: { url: '/asset/Assets/Drive/NetaGateway/ValidateMove', version: '1.0' },
        getDriveApplications: { url: '/asset/Assets/Drive/Applications', version: '1.0' },
        updateAssetNameAndDriveApplication: { url: '/asset/Asset/AdminAsset/{id}', version: '1.0' },
        downloadInstallationReport: { url: '/fileservice/Files/Gateway/{gatewayId}/Latest?fileType={fileType}', version: '1.0' },
        downloadDiagnosticReport: { url: '/ingestioniothub/Diagnostic/DiagnosticReport/{dcuId}', version: '1.0' },
        switchAssetToAnotherGateway: { url: '/asset/Assets/Drive/Gateway/Switch', version: '1.0' },
        validateSwitchGatewayAsset: { url: '/asset/Assets/Drive/{assetId}/Gateway/ValidateSwitch', version: '1.0' },
        getGatewayAssetsList: { url: '/asset/Assets/Drive/Gateway?gatewaySerialNumber={gatewaySerialNumber}', version: '1.0' },
        lastCommandStatusActivateRemoteConnection: { url: '/datacollectionunit/DataCollectionUnit/Gateway/{gatewayId}/Command/Last?requestType={requestType}', version: '1.0' },
        disconnectEnvironmentSensor: { url: '/datacollectionunit/DataCollectionUnit/Gateways/{gatewayId}/EnvironmentSensor/Disconnect', version: '1.0' },
        gatewayEvents: { url: '/eventservice/GlobalEvents/Search', version: '1.0' },
        gatewayEventsAttachments: { url: '/eventservice/GlobalEvents/Attachments', version: '1.0' },
        downloadLogLimitCheck: { url: '/eventservice/GlobalEvents/CheckAttachmentsDownloadLimit', version: '1.0' },
        downloadLogs: { url: '/fileservice/Files/DownloadZip', version: '1.0' },
        exportMessageArchive: { url: '/systemdiagnostic/SystemDiagnostic/MessageArchive/Extract', version: '1.0' },
        connectionHistoryGateway: { url: '/datacollectionunit/DataCollectionUnit/Gateways/{id}/ConnectionStatusHistory', version: '1.0' },
        connectionHistoryAsset: { url: '/asset/GatewayManagement/Assets/{assetId}/ConnectionStatusHistory', version: '1.0' },
        getAssetConnectionHistory: { url: '/datacollectionunit/DataCollectionUnit/Gateways/GetAssetsConnectionHistory', version: '1.0' },
    },
    dataLoggerCommands: {
        getDataLoggerCommandsList: { url: '/datacollectionunit/DataCollectionUnit/Assets/{assetId}/RemoteCommand/Names', version: '1.0' },
        triggerDataLoggerCommands: { url: '/datacollectionunit/DataCollectionUnit/Drives/{assetId}/DataLogger/{loggerType}/Trigger', version: '1.0' },
        subscribeUnsubscribeDataLoggerCommands: { url: '/datacollectionunit/DataCollectionUnit/Drives/{assetId}/SpecialLogger/{loggerType}/SubscribeUnsubscribe', version: '1.0' },
        getSubscribeUnsubscribeCommands: { url: '/datacollectionunit/DriveCommands/DataCollectionUnit/Drives/{assetId}/DataLogger/{loggerType}/SubscribeUnsubscribe', version: '1.0' },
    },
    fleets: {
        barCharts: { url: '/analytics/Analytics/Condition/Statistics/Aggregated', version: '1.0' },
        statistics: { url: '/analytics/Analytics/Condition/Statistics/{tab}', version: '1.0' },
        analyticsAggregated: { url: '/analytics/analytics/condition/aggregated/{tab}', version: '1.0' },
    }
};

/**
 * Formats endpoint objects url to include query parameter.
 * @param {{url:string, version?: string }} endpoint
 * @param {object} placeholders
 * @returns {{url:string, version?: string }}
 */
export const formatEndpoint = (endpoint, placeholders) => {
    return {
        ...endpoint,
        url: formatText(endpoint.url, placeholders)
    };
};

export default endpoints;
